import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityManager } from '@proximus/entity-manager';
import {
  lineEntity,
  ontEntity,
  vlanEntity,
  voipEntity,
} from './entities.config';
import { Line } from './models/line.model';
import { AddOnt, Ont, UpdateOnt } from './models/ont.model';
import { UpdateVlan } from './models/vlan.model';
import { ApplicationState, getProducts } from '../store/reducers';
import { GetProducts } from '../store/actions/products.actions';
import { PlcCodes } from '@dch/products-business-logic';
import { VoipCredentials } from './models/voip-credentials.model';

@Injectable({
  providedIn: 'root',
})
export class ModemChoiceService {
  constructor(private store: Store<ApplicationState>) {}

  fetchLine(circuitId: string): Observable<Line> {
    return EntityManager.getEntity<Line>(lineEntity, { circuitId }).pipe(
      map((entity) => entity.value),
    );
  }

  addOnt(circuitId: string, query: AddOnt): Observable<Ont> {
    const entity = EntityManager.createEntity(lineEntity, { circuitId });
    entity.value = query;
    return EntityManager.saveEntity<Ont>(entity).pipe(
      map((entity) => entity.value),
    );
  }

  updateOnt(
    circuitId: string,
    ncName: string,
    query: UpdateOnt,
  ): Observable<void> {
    const entity = EntityManager.createEntity(ontEntity, { circuitId, ncName });
    entity.value = query;
    return EntityManager.updateEntity(entity).pipe(map(() => undefined));
  }

  removeOnt(circuitId: string, ncName: string): Observable<void> {
    const entity = EntityManager.createEntity(ontEntity, { circuitId, ncName });
    return EntityManager.deleteEntity(entity).pipe(map(() => undefined));
  }

  updateVlan(circuitId: string, query: UpdateVlan): Observable<void> {
    const entity = EntityManager.createEntity(vlanEntity, { circuitId });
    entity.value = query;
    return EntityManager.updateEntity(entity).pipe(map(() => undefined));
  }

  fetchVoipSubscriberNumbers(): Observable<string[]> {
    setTimeout(() => this.store.dispatch(new GetProducts()));
    return this.store.select(getProducts).pipe(
      filter((products) => Boolean(products)),
      map((products) =>
        products
          .filter(
            (product) =>
              product.plc === ('FT' as unknown as PlcCodes) &&
              product.groupMpcUuid === 'DQCOW',
          )
          .map((product) => product.accessNumber),
      ),
    );
  }

  generateVoipCredentials(
    subscriberNumber: string,
  ): Observable<VoipCredentials> {
    const entity = EntityManager.createEntity(voipEntity, { subscriberNumber });
    return EntityManager.saveEntity<VoipCredentials>(entity).pipe(
      map((entity) => entity.value),
    );
  }
}
